import { isBrowserRuntime, sameOriginApiBase } from './sameOriginApiBase';

export { isBrowserRuntime };

/**
 * Merged PromoTix primary + Sharetribe TN search page from the server.
 * Browser-only; SSR should not call this — `loadData` skips it during SSR.
 * @param {string} locationSearch - full query string including leading `?` or not
 * @param {Object} [options]
 * @param {AbortSignal} [options.signal] - abort signal so a superseded search
 *   (e.g. while dragging the map) can be cancelled instead of piling requests
 *   onto the single-threaded server.
 */
export const fetchDiscoverySearchResults = (locationSearch, options = {}) => {
  const { signal } = options;
  const raw = locationSearch && String(locationSearch).trim();
  const qs = raw ? (raw.startsWith('?') ? raw.slice(1) : raw) : '';
  const base = sameOriginApiBase();
  if (!base) {
    return Promise.reject(new Error('Cannot determine discovery search URL (no origin)'));
  }
  const url = `${base}/api/discovery/search-results${qs ? `?${qs}` : ''}`;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
    signal,
  }).then(res => {
    if (!res.ok) {
      return res.text().then(text => {
        throw new Error(text || `Discovery search failed (${res.status})`);
      });
    }
    return res.json();
  });
};
